import React from "react";

export default function ActorIdentityChip({ name, roleLabel }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-[rgb(var(--color-border))] bg-[rgb(var(--color-surface))] px-3 py-1">
      <span className="text-tok-sm text-[rgb(var(--color-text))]">{name}</span>
      <span className="rounded-full bg-[rgb(var(--color-surface-muted))] px-2 py-0.5 text-tok-xs text-[rgb(var(--color-text))]">
        {roleLabel}
      </span>
    </div>
  );
}
